import * as React from 'react';
import styled from 'styled-components/macro';
import ProductInfoTooltip from 'lib/components/ProductInfoTooltip/ProductInfoTooltip';
import { useTheme } from 'styled-components/macro';

const DropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 6px); // space below the trigger
  right: 0;
  width: 175px;
  background: ${({ theme }) => theme.colors.white[100]};
  border: 1px solid ${({ theme }) => theme.colors.secondary[20]};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 999;
`;

const DropdownItem = styled.button<{
  color: string;
  bgColor: string;
  onHoverBgColor: string;
}>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 8px 12px;
  background: ${props => props.bgColor};
  border: none;
  width: 175px;
  border-radius: 5px;
  font-weight: 600;
  color: ${props => props.color};
  cursor: pointer;

  &:hover {
    background: ${props => props.onHoverBgColor};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

type DropdownItemProps = {
  icon: React.ReactNode;
  label: React.JSX.Element | string;
  onClick: () => void;
  disabled?: boolean;
  productFeatureId?: number;
  nextPlan?: string;
  showItem?: boolean;
};

type Props = {
  dropdownItems: DropdownItemProps[];
};

export const AddonDropdown = (props: Props) => {
  const { dropdownItems } = props;
  const themes = useTheme();
  return (
    <DropdownContainer>
      {dropdownItems.map((item, index) => {
        const itemContent = (
          <DropdownItem
            bgColor={themes.colors.secondary[5]}
            onHoverBgColor={themes.colors.secondary[5]}
            color={themes.colors.secondary[100]}
            key={index}
            onClick={item.onClick}
            disabled={item.disabled}
          >
            {item.icon}
            {item.label}
          </DropdownItem>
        );
        if (!item.showItem) return null;

        return item.disabled ? (
          <div style={{ width: '175px' }} key={index}>
            <ProductInfoTooltip
              width={'fit-content'}
              style={{
                left: '-70px',
                top: '-50px',
              }}
              productFeatureId={item.productFeatureId}
              nextPlan={item.nextPlan}
            >
              {itemContent}
            </ProductInfoTooltip>{' '}
          </div>
        ) : (
          itemContent
        );
      })}
    </DropdownContainer>
  );
};
